import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, InputAdornment } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogPrazo = ({ onClose, initial, ...props }) => {
    const formik = useFormik({
        initialValues: {
            prazo: initial
        },
        validationSchema: yup.object({
            prazo: yup.number().min(0, 'O valor não pode ser menor que 0').required('O campo é obrigatório')
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values);
        }
    });
    // Formik fix dialog reuse
    useEffect(() => {
        formik.resetForm();
        formik.setValues({
            prazo: initial
        });
    }, [initial]);
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Alterar prazo</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Prazo *' InputProps={{
            endAdornment: <InputAdornment position='end'>dias</InputAdornment>
        }} type='number' name='prazo' value={formik.values?.prazo} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.prazo && Boolean(formik.errors.prazo)} helperText={formik.touched.prazo && formik.errors.prazo}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            formik.handleSubmit();
        }} disabled={!formik.isValid || !formik.dirty || formik.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogPrazo;
